"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HogastInvoiceMessage = exports.InvoiceMessage = void 0;
const base_html_1 = require("./base-html");
const util_1 = require("../util");
const model_1 = require("../model");
class InvoiceMessage {
    constructor(invoice, billingUrl) {
        this.invoice = invoice;
        this.billingUrl = billingUrl;
        this.title = `Ihre Pentacode Rechnung ${this.invoice.number}`;
    }
    get recipient() {
        return this.invoice.raw.customer_email;
    }
    get replyTo() {
        return "mail@pentacode.app";
    }
    get attachments() {
        return [
            {
                filename: `rechnung_pentacode_${this.invoice.number}.pdf`,
                path: this.invoice.pdf,
                contentType: model_1.MimeType.PDF,
            },
        ];
    }
    get text() {
        return `
Sehr geehrter Pentacode Kunde,

Im Anhang finden Sie Ihre Rechnung ${this.invoice.number} vom ${(0, util_1.formatDate)(this.invoice.billingDate)}.

Alternativ können Sie die Rechnung auch online einsehen und herunterladen:

${this.billingUrl}

Mit freundlichen Grüßen,
Ihr Pentacode Team
`;
    }
    get html() {
        return (0, base_html_1.base)(`
            ${(0, base_html_1.paragraph)(`Sehr geehrter Pentacode Kunde,`)}

            ${(0, base_html_1.paragraph)(`Im Anhang finden Sie Ihre Rechnung ${(0, base_html_1.bold)(this.invoice.number)} vom ${(0, base_html_1.bold)((0, util_1.formatDate)(this.invoice.billingDate))}.`)}

            ${(0, base_html_1.paragraph)(`Alternativ können Sie die Rechnung auch online einsehen und herunterladen:`)}

            ${(0, base_html_1.button)("Rechnungen Einsehen", this.billingUrl)}

            ${(0, base_html_1.paragraph)(`
                Mit freundlichen Grüßen,<br>
                Ihr Pentacode Team
            `)}
        `);
    }
}
exports.InvoiceMessage = InvoiceMessage;
class HogastInvoiceMessage {
    constructor(invoice) {
        this.invoice = invoice;
        this.title = `Pentacode Rechnung ${this.invoice.number}`;
    }
    get recipient() {
        var _a, _b;
        return (_b = (_a = this.invoice.customer) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.hogastUnionEmail;
    }
    get replyTo() {
        return "mail@pentacode.app";
    }
    get attachments() {
        const attachments = [];
        if (this.invoice.pdf) {
            attachments.push({
                filename: `pentacode_rechnung_${this.invoice.number}.pdf`,
                path: this.invoice.pdf,
                contentType: model_1.MimeType.PDF,
            });
        }
        if (this.invoice.hogastXmlInvoice) {
            attachments.push({
                filename: `pentacode_rechnung_${this.invoice.number}.xml`,
                path: this.invoice.hogastXmlInvoice,
                contentType: model_1.MimeType.XML,
            });
        }
        if (this.invoice.hogastXmlDeliveryNote) {
            attachments.push({
                filename: `pentacode_lieferschein_${this.invoice.number}.xml`,
                path: this.invoice.hogastXmlDeliveryNote,
                contentType: model_1.MimeType.XML,
            });
        }
        return attachments;
    }
    get text() {
        return `
Sehr geehrte Damen und Herren,

Im Anhang finden Sie Ihre Rechnung ${this.invoice.number} vom ${(0, util_1.formatDate)(this.invoice.billingDate)}.

Mit freundlichen Grüßen,
Ihr Pentacode Team
`;
    }
    get html() {
        return (0, base_html_1.base)(`
            ${(0, base_html_1.paragraph)(`Sehr geehrte Damen und Herren,`)}

            ${(0, base_html_1.paragraph)(`Im Anhang finden Sie Ihre Rechnung ${(0, base_html_1.bold)(this.invoice.number)} vom ${(0, base_html_1.bold)((0, util_1.formatDate)(this.invoice.billingDate))}.`)}

            ${(0, base_html_1.paragraph)(`
                Mit freundlichen Grüßen,<br>
                Ihr Pentacode Team
            `)}
        `);
    }
}
exports.HogastInvoiceMessage = HogastInvoiceMessage;
//# sourceMappingURL=invoice.js.map